import { MatDateFormats } from '@angular/material/core';
const MONTH_YEAR_FORMAT: MatDateFormats = 
{
    parse: 
    {
        dateInput: 'MM/yyyy'
    },
    display: 
    {
        dateInput: 'MM/yyyy',
        monthYearLabel: 'MMM yyyy',
        dateA11yLabel: 'LLLL',
        monthYearA11yLabel: 'MMMM yyyy'
    }
};
export { MONTH_YEAR_FORMAT };